import axios from "axios";
import Swal from "sweetalert2";

const THEME = "#f48226";

/**
 * Asks for confirmation, then downloads the application as a generated PDF
 * (real data from the server, not a screenshot of the page). No preview is shown.
 */
export async function downloadApplicationPdf(appId, appNumber) {
  const label = appNumber ? ` ${appNumber}` : "";

  const confirmation = await Swal.fire({
    title: "Download PDF?",
    text: `Do you want to download application${label} as a PDF?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Download",
    cancelButtonText: "Cancel",
    confirmButtonColor: THEME,
    reverseButtons: true,
  });
  if (!confirmation.isConfirmed) return false;

  Swal.fire({
    title: "Preparing your PDF...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    const response = await axios.get(`/applications/application_pdf/${appId}/`, {
      responseType: "blob",
    });

    const disposition = response.headers["content-disposition"] || "";
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
    const filename = match
      ? decodeURIComponent(match[1])
      : `ECU_Application_${appNumber || appId}.pdf`;

    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/pdf" })
    );
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    Swal.close();
    return true;
  } catch (error) {
    const status = error.response && error.response.status;
    Swal.fire({
      title: "Download failed",
      text:
        status === 403
          ? "You do not have access to this application."
          : status === 404
          ? "This application could not be found."
          : "The PDF could not be generated. Please try again.",
      icon: "error",
      confirmButtonColor: THEME,
    });
    return false;
  }
}